var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
window.Works.CoauthorTagEdit = function (superClass) {
  extend(CoauthorTagEdit, superClass);
  function CoauthorTagEdit() {
    return CoauthorTagEdit.__super__.constructor.apply(this, arguments);
  }
  CoauthorTagEdit.prototype.initialize = function (options) {
    return CoauthorTagEdit.__super__.initialize.call(this, {
      html: true,
      placement: 'top',
      show_delay: 50,
      hide_delay: 200,
      content: function (_this) {
        return function () {
          return _this.content();
        };
      }(this),
      on_shown: function (_this) {
        return function () {
          return _this.initUi(_this._popover_el());
        };
      }(this)
    });
  };
  CoauthorTagEdit.prototype.initUi = function (el) {
    this.ui = {
      name: el.find('.js-works-coauthor-edit-name'),
      email: el.find('.js-works-coauthor-edit-email'),
      buttons: el.find('.js-works-coauthor-save-or-cancel'),
      save: el.find('.js-works-coauthor-save'),
      cancel: el.find('.js-works-coauthor-cancel'),
      errors: el.find('.js-works-coauthor-errors')
    };
    if (this._allowEdit()) {
      return this._initListeners();
    }
  };
  CoauthorTagEdit.prototype._initListeners = function () {
    this.ui.name.click(function (_this) {
      return function () {
        return _this._editName();
      };
    }(this));
    this.ui.name.hover(function (_this) {
      return function () {
        return _this._editName();
      };
    }(this));
    this.ui.email.click(function (_this) {
      return function () {
        return _this._editEmail();
      };
    }(this));
    this.ui.email.hover(function (_this) {
      return function () {
        return _this._editEmail();
      };
    }(this));
    this.ui.save.click(function (_this) {
      return function () {
        return _this._save();
      };
    }(this));
    return this.ui.cancel.click(function (_this) {
      return function () {
        return _this._hide();
      };
    }(this));
  };
  CoauthorTagEdit.prototype._allowEdit = function () {
    return !this.model.has('tagged_user_id');
  };
  CoauthorTagEdit.prototype.content = function () {
    return JST['work_tags/templates/coauthor_tag_edit']({
      tag: this.model
    });
  };
  CoauthorTagEdit.prototype._editName = function () {
    this._switchToButtons();
    return this.ui.name.attr('readonly', false);
  };
  CoauthorTagEdit.prototype._editEmail = function () {
    this._switchToButtons();
    return this.ui.email.attr('readonly', false);
  };
  CoauthorTagEdit.prototype._switchToButtons = function () {
    this.freeze();
    return this.ui.buttons.removeClass('hidden');
  };
  CoauthorTagEdit.prototype._save = function () {
    var changed, error, previous;
    changed = {};
    if (!(this.ui.name.is('readonly') || this.ui.name.val() === this.model.get('name'))) {
      changed['name'] = this.ui.name.val();
    }
    if (!(this.ui.email.is('readonly') || this.ui.email.val() === this.model.get('email'))) {
      changed['email'] = this.ui.email.val();
    }
    previous = this.model.clone();
    if (this.model.set(changed, {
      validate: true
    })) {
      previous.rejectAsSuggestion();
      return this._hide();
    } else if (error = this.model.validationError) {
      return this._showError(error);
    }
  };
  CoauthorTagEdit.prototype._showError = function (error) {
    if (error.email) {
      this.ui.email.parent().addClass('has-error');
    } else {
      this.ui.email.parent().removeClass('has-error');
    }
    if (error.name) {
      this.ui.name.parent().addClass('has-error');
    } else {
      this.ui.name.parent().removeClass('has-error');
    }
    this.ui.errors.html('');
    return _(error).each(function (_this) {
      return function (errorText) {
        return _this.ui.errors.append($('<div/>')).addClass('alert alert-danger').attr('role', 'alert').text(errorText);
      };
    }(this));
  };
  return CoauthorTagEdit;
}(HoverPopover);
window.extend = extend;
window.hasProp = hasProp;